'use strict';

import {
    getUrlParam,
    getUrlSearchQuery, isMapOpened,
    isNumeric,
    isOptionsCardOpened,
    isUrlHasParam, lockScreenOrientation, removeActiveGalleryItem,
    userPrevent
} from "../../../functions";
import {cardsData, settingsData} from "../../../settings";
import {PagesForPagination} from "../../../common";
import {menuHandler} from "../../menu/menu";
import {createModal} from "../../cards/urlParamModal";
import {closeHandler, openOptionsCard} from "../../cards/optionsCards";
import {closeOptionsCard} from "../../cards/cardsFunctions";
import { getCurrentLang } from '../langSwitcher/langSwitcher';

export class Pagination {
    static #prevent = false;
    static #history = [];

    constructor() {
        this.#addOnPopStateListener();
    }

    paginate(args) {
        if (window.history.state?.page === undefined && args.source !== 'widgetsInit' && args.source !== 'flatCloseButtonHandler')
            return;
        const pValue = getUrlParam('p');
        switch (args.source) {
            case 'widget-close-button':
                if (isMapOpened()) {
                    Pagination.#winHistPushState('map');
                    break;
                }
                if (isOptionsCardOpened())
                    break;
                switch (settingsData.activeViewMode) {
                    case 'cylinder':
                        Pagination.#winHistPushState('search');
                        break;
                    case 'orbit':
                        Pagination.#winHistPushState('3dModel');
                        break;
                }
                break;
            case 'viewModesSwitching':
            case 'logoHandler':
                Pagination.#winHistPushState('3dModel');
                break;
            case 'flatCloseButtonHandler':
            case 'cardsBackButton':
                switch (settingsData.activeViewMode) {
                    case 'orbit':
                        Pagination.#winHistPushState('3dModel');
                        break;
                    case 'cylinder':
                        Pagination.#winHistPushState('search');
                        break;
                    default:
                        Pagination.#winHistPushState('search');
                        break;
                }
                break;
            case 'urlModalCloseButton':
            case 'searchBackNavButton':
            case 'appModal':
                Pagination.#winHistPushState('3dModel');
                menuHandler({target:{dataset:{menuItem:pValue}}});
                break;
            case 'widgetsInit':
                if (isNumeric(pValue) || config.features.amenities.some(amenity => amenity.engineId === pValue)) {
                    Pagination.#winHistPushState('3dModel');
                    createModal(pValue);
                    break;
                } else if ( /* !config.contactWidget.active && */ Object.values(PagesForPagination).includes(pValue)) {
                    const interval = setInterval(() => {
                        if (settingsData.allCrmData) {
                            clearInterval(interval);
                            Pagination.#winHistPushState(pValue);
                            menuHandler({target: {dataset: {menuItem: pValue}}});
                        }
                    }, 100);
                    setTimeout(() => {
                        clearInterval(interval);
                    }, 5000);
                    break;
                }

                Pagination.#winHistPushState('3dModel');
                break;
            case 'menuHandler':
                const menuItem = args.menuItem;
                if (Object.values(PagesForPagination).includes(menuItem))
                    if (isOptionsCardOpened()) {
                        setTimeout(() => {
                            Pagination.#winHistPushState(menuItem);
                        }, 500);
                    } else {
                        Pagination.#winHistPushState(menuItem);
                    }

                break;
            case 'openOptionsCard':
                Pagination.#winHistPushState(args.flatId, args.isSimilarApartment);
                break;
            default:
                console.log('paginationHandler: default case');
                break;
        }
    }
    
    query(key,value) {
        const url = new URL(window.location.href);
        url.searchParams.set(key,value);
        let p = url.searchParams.get('p');
        if (!p) {
            p = url.origin;
        }
        
        Pagination.#history.push({page: p}, document.title, `/${url.search}`);
        window.history.pushState({page: p}, document.title, `/${url.search}`);
    }

    #addOnPopStateListener() {
        window.onpopstate = (e) => {
            if (userPrevent() ||
                !settingsData.slideShowed) {
                e.preventDefault();

                return;
            }

            if (!window.history.state)
                location.reload();

            removeActiveGalleryItem();

            const pValue = getUrlParam('p');
            const lang = getUrlParam('lang');
            if (isNumeric(pValue)) {
                const crmApartmentData = settingsData?.allCrmData.find(item => item.bmbyPropID === parseInt(pValue));
                openOptionsCard({object: crmApartmentData});
            } else if (Object.values(PagesForPagination).includes(getUrlParam('p'))) {
                menuHandler({target: {dataset: {menuItem: getUrlParam('p')}}});
                if (isOptionsCardOpened())
                    closeHandler();
            }
            
            if (lang) {
                const current = getCurrentLang();
                if (lang !== current) {
                    const langItem = document.querySelector(`.lang__item[data-lang="${lang}"`);
                    langItem && langItem.click();
                }
            }
            

            lockScreenOrientation();
        };
    }

    static set prevent(value) {
        Pagination.#prevent = value;
    }

    static get prevent() {
        return Pagination.#prevent;
    }

    static #winHistPushState(page, isSimilarApartment) {
        if (window.history.state?.page === page.toString()
          || isNumeric(window.history.state?.page) && isNumeric(page) && !isSimilarApartment
          || isNumeric(window.history.state?.page) && cardsData.cardMode.isAmenities
          || config.features.amenities.some(amenity => amenity.engineId === page))
            return;

        const modifiedSearchQuery = getModifiedSearchQuery(page);
        Pagination.#history.push({page: page.toString()}, document.title, `/?${modifiedSearchQuery}`)
        window.history.pushState({page: page.toString()}, document.title, `/?${modifiedSearchQuery}`);

        function getModifiedSearchQuery(pageToPush) {
            let splitQuery = getUrlSearchQuery().split('&');
            splitQuery[0] = splitQuery[0].replace('?', '');
            const paramToPush = `p=${pageToPush}`;
            if (!isUrlHasParam('p') && splitQuery[0] !== '') {
                splitQuery.unshift(paramToPush);
            } else {
                splitQuery[0] = paramToPush;
            }

            if (splitQuery.length <= 1)
                return splitQuery;
            return splitQuery.join('&');
        }
    }

    static get history() {
        return Pagination.#history;
    }
}
